var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.editorComponent,_vm._g(_vm._b({ref:"editor",tag:"component",class:['eum-editor-proxy', ..._vm.classNames]},'component',{ ..._vm.$attrs, type: _vm.type, mode: _vm.mode },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }